import { render, staticRenderFns } from "./Monaco.vue?vue&type=template&id=41d0567f&"
import script from "./Monaco.vue?vue&type=script&lang=js&"
export * from "./Monaco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../_vue-loader@15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mario/Documents/aygtech/weexbox-service/frontend/node_modules/_vue-hot-reload-api@2.3.3@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('41d0567f', component.options)
    } else {
      api.reload('41d0567f', component.options)
    }
    module.hot.accept("./Monaco.vue?vue&type=template&id=41d0567f&", function () {
      api.rerender('41d0567f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/_vue-monaco-editor@0.0.19@vue-monaco-editor/src/Monaco.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-monaco-editor@0.0.19@vue-monaco-editor/src/Monaco.vue
// module id = ./node_modules/_vue-monaco-editor@0.0.19@vue-monaco-editor/src/Monaco.vue
// module chunks = 1